import { buildInsightContext } from "./trajectories";
import { detectInsights } from "./detectors";
import { rankInsights } from "./rankInsights";
import { phraseInsight } from "./phrase";
import { resolveZoneText, resolveInsightCopy } from "../copy";

/**
 * Insights from the map, end to end: score the last periods (trajectories),
 * run the detectors, rank, phrase. Returns [] when the period has no grain.
 *
 * Each insight: { id, kind, subject, subjects, subjectIds, bucketIds,
 * numbers, stakes, magnitude, confidence, rank, claim, why }.
 */
export const deriveInsights = ({
  historyTree,
  period,
  signalMetaById,
  signalCategories,
  fallbackDatedDatasets,
  prioritiesCopy,
  titleByContentType,
  displayOf,
}) => {
  const ctx = buildInsightContext({ historyTree, period, signalMetaById, signalCategories, fallbackDatedDatasets });
  if (!ctx) return { insights: [], meta: null };
  const zones = resolveZoneText(prioritiesCopy);
  const copy = resolveInsightCopy(prioritiesCopy);
  const ranked = rankInsights(detectInsights(ctx));
  const insights = ranked.map((c) => ({
    ...c,
    bucketIds: [...new Set(c.subjectIds.map((id) => ctx.bucketOfNode.get(id)?.nodeId).filter(Boolean))],
    ...phraseInsight(c, { zones, copy, meta: ctx.current.meta, titleByContentType, displayOf }),
  }));
  return { insights, meta: ctx.current.meta };
};
